export default __webpack_public_path__ + "static/Fellix-ExtraBoldItalic-62ce1ab94bb51fb9277463d1893aaf91.otf";